import { createFileRoute } from '@tanstack/react-router';
import { LoadingPlacesClient } from '@/features/logistics/LoadingPlacesClient';

export const Route = createFileRoute('/_shell/logistics/loading-places')({
  component: LoadingPlacesClient,
});
